export const tenantDomainTheme = {
    data() {
        return {
            tenantDomainTheme: window.tenantDomainTheme,
        }
    },

    computed: {
        lowerCaseTenantDomainTheme() {
            return this.tenantDomainTheme.toLowerCase();
        },
    },
};



// WEBPACK FOOTER //
// ./src/Assets/mixins/tenantDomainTheme.js